import { categoryAPI } from './api';
import type { Category, CategoryTree } from '../types';

export interface CategoryFilters {
  isActive?: boolean;
  parentOnly?: boolean;
  showOnHomepage?: boolean;
  search?: string;
}

// Category Service
export const categoryService = {
  // Get all categories with filters
  async getCategories(filters: CategoryFilters = {}): Promise<{ categories: Category[]; pagination?: any }> {
    const params: any = {};
    
    if (filters.isActive !== undefined) {
      params.isActive = filters.isActive;
    }
    if (filters.parentOnly !== undefined) {
      params.parentOnly = filters.parentOnly;
    }
    if (filters.showOnHomepage !== undefined) {
      params.showOnHomepage = filters.showOnHomepage;
    }
    if (filters.search) {
      params.search = filters.search;
    }

    const response = await categoryAPI.getAll(params);
    return (response.data as any).data;
  },

  // Get category tree (hierarchical structure)
  async getCategoryTree(isActive: boolean = true): Promise<CategoryTree> {
    const response = await categoryAPI.getTree({ isActive });
    return (response.data as any).data;
  },

  // Get category by ID
  async getCategoryById(id: string): Promise<Category> {
    const response = await categoryAPI.getById(id);
    return (response.data as any).data.category;
  },

  // Get category by slug
  async getCategoryBySlug(slug: string): Promise<Category> {
    const response = await categoryAPI.getBySlug(slug);
    return (response.data as any).data.category;
  },

  // Get active parent categories only
  async getActiveParentCategories(): Promise<Category[]> {
    const response = await this.getCategories({ 
      isActive: true, 
      parentOnly: true 
    });
    return response.categories;
  },

  // Get all active categories (flattened)
  async getAllActiveCategories(): Promise<Category[]> {
    const response = await this.getCategories({ isActive: true });
    return response.categories;
  }
};
